import { render } from "./OfferingsTag.vue?vue&type=template&id=4bdb47f4"
import script from "./OfferingsTag.vue?vue&type=script&lang=js"
export * from "./OfferingsTag.vue?vue&type=script&lang=js"
script.render = render

export default script